"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchOptInStatusRequestStatus = exports.getIsNewUserFromSignup = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var _reselect = require("reselect");

var getModuleState = function getModuleState(state) {
  return state.optIn;
};

var getIsNewUserFromSignup = (0, _reselect.createSelector)([getModuleState], function (state) {
  return state.get('isUserFromSignup');
});
exports.getIsNewUserFromSignup = getIsNewUserFromSignup;
var getFetchOptInStatusRequestStatus = (0, _getRequestStatus.default)(_actions.OptInActionTypes.FETCH_OPT_IN_STATUS);
exports.getFetchOptInStatusRequestStatus = getFetchOptInStatusRequestStatus;